import React from "react";
import { useTranslation } from "react-i18next";

import { EditMode } from "../../../types/edit_mode";
import { useBookingModuleContext } from "../../providers/booking_module_context_provider";
import { useBookingRowsContext } from "../context/booking_rows_context";
import { InfoOverlay } from "./info_overlay";

type SplitModeWarningOverlayProps = {
  headerRef: React.MutableRefObject<HTMLDivElement>;
};

export const SplitModeWarningOverlay = ({ headerRef }: SplitModeWarningOverlayProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "infoOverlay" });
  const { setHeaderDisabled } = useBookingModuleContext();
  const { setEditMode } = useBookingRowsContext();

  const handleClose = () => {
    setEditMode(EditMode.Disabled);
    setHeaderDisabled(false);
  };

  return <InfoOverlay headerRef={headerRef} message={t("splitModeMessage")} onClose={handleClose} />;
};
